export enum GroupChallengeRoute {
  challenges = 'challenges',
  challengeDetails = 'challenge-details',
  challengesSelect = 'challenges-select',
}
